import { useEffect, useRef, useState } from 'react';
import { useNavigation } from 'react-router';

export function NavigationProgress() {
  const navigation = useNavigation();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval>>(null);
  const visibleRef = useRef(false);

  useEffect(() => {
    visibleRef.current = visible;
  }, [visible]);

  useEffect(() => {
    if (navigation.state === 'loading') {
      setProgress(0);
      setVisible(true);

      intervalRef.current = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) return prev;
          return prev + (90 - prev) * 0.1;
        });
      }, 100);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }

      if (visibleRef.current) {
        setProgress(100);
        const timeout = setTimeout(() => {
          setVisible(false);
          setProgress(0);
        }, 200);
        return () => clearTimeout(timeout);
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [navigation.state]);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-9999 h-0.5">
      <div className="h-full bg-primary transition-all duration-200 ease-out" style={{ width: `${progress}%` }} />
    </div>
  );
}
